import { useEffect, useState } from "react";
import Mode from "../../components/styles/Mode";
import { extractUTMParameters, isPlausibleHumanName, isValidEmail, isValidUSPhoneNumber } from "../../utilities/utils";
import { useNavigate } from "react-router-dom";
import ProgressWithStatuses from "../../components/ProgressWithStatuses";
import requests from "../../handlers/requests";
import Flexbox from "../../components/Flexbox";
import cookies from "../../utilities/Cookies";
import { updatedarkmode } from "../../features/mode";
import { useDispatch } from "react-redux";

const LeadLoading = () => {

    // recieves email, phone firstname, lastname & contact_id  [DONE]
    // wait 20 seconds for ghl to send data to server while simulating a loading page [DONE]
    // check if user details exists in database [DONE]
    // if exists:
    //     checks if contact details are not fake or test details [DONE]
    //     if tests:
    //         send to /lead-form page with contact_id, firstname, lastname, phone, email, save=true & error [DONE]
    //     else:
    //        send to /lead url params contact_id & source=ghl-survey [DONE]
    // else:
    //     send to /lead-form page with contact_id, firstname, lastname, phone, email, save=false & error [DONE]

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [loading,] = useState(true)
    const [dontRunLoadFunction, setDontRunLoadFunction] = useState(false)


    const getUrlParams = () => {
        const urlParams = new URLSearchParams(window.location.search)
        const email = urlParams.get('email')
        const phone = urlParams.get('phone')
        const firstName = urlParams.get('first_name')
        const lastName = urlParams.get('last_name')
        const contactId = urlParams.get('contact_id')
        const page = urlParams.get('page')
        const trusted_cert_url = urlParams.get('trusted_form_cert_url')

        return { email, phone, firstName, lastName, contactId, page, trusted_cert_url }
    }

    /**
     * Sends Ping to DB to check if user exits
     */
    const pingDB = (count) => {
        const { email, phone, firstName, lastName, contactId: id, page, trusted_cert_url } = getUrlParams()

        if (count === 3)
            return

        requests.post(`/api/users/${id}/exists`, { trusted_cert_url }, () => { }, () => { }, () => { }, () => { },
            (res) => {
                if (res.exists) {
                    setDontRunLoadFunction(true)
                    checkDetails(email, phone, firstName, lastName, id, page, trusted_cert_url)
                }
                console.log('Will ping the server again in 20s')
                setTimeout(() => {
                    pingDB(count + 1)
                }, 20000);
            },
            null
        )
    }

    const load = async () => {
        const { email, phone, firstName, lastName, contactId, page, trusted_cert_url } = getUrlParams()

        if (firstName && lastName && email && phone && contactId)
            checkIfExists(contactId, firstName, lastName, email, phone, page, trusted_cert_url)
        else
            sendToLeadForm({
                id: '',
                email: '',
                first_name: '',
                last_name: '',
                phone: '',
                save: false,
                error: 'An unexpected error occured while saving your data. Kindly verify your details.',
                page: page,
                trusted_cert_url
            })
    }

    const checkIfExists = async (id, firstName, lastName, email, phone, page, trusted_cert_url) => {
        requests.post(`/api/users/${id}/exists`, { trusted_cert_url }, () => { }, () => { }, () => { }, () => { },
            (res) => {
                if (res.exists)
                    checkDetails(email, phone, firstName, lastName, id, page, trusted_cert_url)
                else
                    sendToLeadForm({
                        id: id,
                        email: email,
                        first_name: firstName,
                        last_name: lastName,
                        phone: phone,
                        save: false,
                        error: 'An unexpected error occured while saving your data. Kindly verify your details.',
                        page: page,
                        trusted_cert_url
                    })
            },
            null
        )
    }

    const checkDetails = (email, phone, first_name, last_name, id, page, trusted_cert_url) => {
        if (isValidEmail(email) && isValidUSPhoneNumber(phone) && isPlausibleHumanName(first_name) && isPlausibleHumanName(last_name)) {
            navigate(`/lead?contact_id=${id}&source=ghl-survey&page=${page}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`, { replace: true })
        } else {
            sendToLeadForm({
                id, first_name, last_name, email, phone, save: true, error: 'We are unable to process your data, please provide valid contact details', page: page, trusted_cert_url
            })
        }
    }

    const sendToLeadForm = ({ id, first_name, last_name, email, phone, save, error, page, trusted_cert_url }) => {
        navigate(`/lead-form?contact_id=${id}&firstname=${first_name}&lastname=${last_name}&email=${email}&phone=${phone}&trusted_cert_url=${trusted_cert_url}&saved=${save}&error=${error}&page=${page}${extractUTMParameters(['cluid', 'utm_source', 'utm_medium', 'utm_content', 'utm_campaign', 'utm_term', 'utm_id', 'ad_id', 'tw_source', 'tw_adid'])}`, { replace: true })
    }

    const validateData = () => {
        const { email, phone, firstName, lastName, contactId, page, trusted_cert_url } = getUrlParams()
        if (isValidEmail(email) && isValidUSPhoneNumber(phone) && isPlausibleHumanName(firstName + " " + lastName))
            return { success: true, payload: {} }
        return {
            success: false,
            payload: { email, phone, first_name: firstName, last_name: lastName, id: contactId, save: false, error: 'We are unable to process your data, please provide valid details', page: page, trusted_cert_url }
        }
    }

    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))

        let counter = 1
        // validate data
        if (validateData().success)
            pingDB(counter)
        else
            sendToLeadForm({ ...validateData().payload })

        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            <div className="turbo-loading-page">
                <div className="mid margin-auto">
                    <div style={{ padding: '20px' }}>
                        {loading && <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                            <ProgressWithStatuses onComplete={() => {
                                if (!dontRunLoadFunction)
                                    load()
                            }} />
                        </Flexbox>}
                    </div>
                </div>
            </div>
        </Mode>
    );
}

export default LeadLoading;